import { createFileRoute } from '@tanstack/react-router'
import { ForecastPilotPage } from '~/components/routes/categories/forecastPilot/ForecastPilotPage'
import { FORECAST_PILOT_READ } from '~/components/routes/categories/forecastPilot/pilotLabels'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/categories/reappro/forecast-pilot')({
  staticData: {
    permission: FORECAST_PILOT_READ,
  },
  component: ForecastPilotPage,
})
withRoutePermissions(Route)
